export interface PatientAddress {
  line1?: string;
  city?: string;
  state?: string;
  postalCode?: string;
}

export function formatPatientAddress(address: unknown): string {
  if (!address || typeof address !== 'object') {
    return 'Address unavailable';
  }

  const addr = address as PatientAddress;
  const { line1, city, state, postalCode } = addr;

  // Filter out empty/undefined values and join with proper formatting
  // Trim each field to handle whitespace padding from API responses
  const parts: string[] = [];
  if (line1?.trim()) parts.push(line1.trim());
  if (city?.trim()) parts.push(city.trim());

  // Format state and postal code together if both exist
  const stateZip = [state?.trim(), postalCode?.trim()].filter(Boolean).join(' ');
  if (stateZip) parts.push(stateZip);

  const formatted = parts.join(', ');
  return formatted || 'Address unavailable';
}
